var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWbsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1851_13394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2461 0H2.63672C1.18055 0 0 1.18055 0 2.63672V8.78906H29.8828V2.63672C29.8828 1.18055 28.7023 0 27.2461 0Z",
    fill: "#6692EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6753 25.1348C87.8558 24.6647 86.8477 24.6688 86.0323 25.1459L59.9414 40.4037V27.4219C59.9414 26.4772 59.436 25.6048 58.6167 25.1348C57.7972 24.6647 56.7891 24.6688 55.9737 25.1459L29.8828 40.4037V14.0625H0V87.3633C0 88.8195 1.18055 90 2.63672 90H87.3633C88.8195 90 90 88.8195 90 87.3633V27.4219C90 26.4772 89.4946 25.6048 88.6753 25.1348ZM40.4297 71.4551C40.4297 72.9113 39.2491 74.0918 37.793 74.0918H27.2461C25.7899 74.0918 24.6094 72.9113 24.6094 71.4551V60.9082C24.6094 59.452 25.7899 58.2715 27.2461 58.2715H37.793C39.2491 58.2715 40.4297 59.452 40.4297 60.9082V71.4551ZM70.4883 71.4551C70.4883 72.9113 69.3077 74.0918 67.8516 74.0918H57.3047C55.8485 74.0918 54.668 72.9113 54.668 71.4551V60.9082C54.668 59.452 55.8485 58.2715 57.3047 58.2715H67.8516C69.3077 58.2715 70.4883 59.452 70.4883 60.9082V71.4551Z",
    fill: "#021948"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1851_13394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbsIcon);
export default __webpack_public_path__ + "static/media/wbsIcon.ad3fd36c5d44b26cf4de3aa18a721f28.svg";
export { ForwardRef as ReactComponent };